import './Profile.scss';

import { PROFIL_TABS, ROUTE_PROFILE_NAME } from '../../utils/constants';
import { Route, Routes, useBlocker, useNavigate } from 'react-router-dom';
import {
  checkUser,
  selectIsFetchingUserExistes,
  selectUserExists
} from '../../ducks/entities';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import Loader from '../../components/Loader/Loader';
import ProfileCreation from './ProfileCreation';
import Status from './Status';
import UnsavedWarningModal from '../../components/UnsavedWarningModal/UnsavedWarningModal';
import bannerImg from '../../assets/images/ubisoft-playtest-profile-creation-banner.webp';
import bannerImgMobile from '../../assets/images/ubisoft-playtest-profile-creation-banner-mobile.webp';
import messages from './messages';
import { selectAuth } from '../../ducks/auth';
import { selectLocalSettings } from '../../ducks/settings';
import { useIntl } from 'react-intl';

const Profile = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const intl = useIntl();
  const userExists = useSelector(selectUserExists);
  const isFetchingUserExists = useSelector(selectIsFetchingUserExistes);
  const navigate = useNavigate();
  const lang = useSelector(selectLocalSettings);
  const [isFormModified, setFormModified] = useState(false);
  const [showingWarning, setShowingWarning] = useState(false);
  const [showedWarning, setShowedWarning] = useState(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isFormModified &&
      !showingWarning &&
      !showedWarning &&
      currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (userExists === undefined) return;
    if (location.pathname === `/${lang}/${ROUTE_PROFILE_NAME}`) {
      userExists
        ? navigate(
            `${location.pathname.substring(0, 6)}/${ROUTE_PROFILE_NAME}/${
              PROFIL_TABS[0].pathname
            }`,
            { replace: true }
          )
        : navigate(
            `${location.pathname.substring(0, 6)}/${ROUTE_PROFILE_NAME}/create`,
            { replace: true }
          );
    } else {
      userExists
        ? PROFIL_TABS.some(
            (t) =>
              `/${lang}/${ROUTE_PROFILE_NAME}/${t.pathname}` ===
              location.pathname
          )
          ? navigate(location.pathname, { replace: true })
          : navigate(
              `${location.pathname.substring(0, 6)}/${ROUTE_PROFILE_NAME}/${
                PROFIL_TABS[0].pathname
              }`,
              { replace: true }
            )
        : navigate(
            `${location.pathname.substring(0, 6)}/${ROUTE_PROFILE_NAME}/create`
          );
    }
  }, [userExists, lang]);

  useEffect(() => {
    if (auth.userId) dispatch(checkUser());
  }, [auth.userId]);
  return (
    <div className="page profile">
      {blocker.state === 'blocked' && (
        <UnsavedWarningModal
          onClose={() => blocker.reset()}
          onClick={() => {
            blocker.proceed();
            setFormModified(false);
          }}
        />
      )}
      <div className="page__header">
        <img
          src={bannerImg}
          width="auto"
          alt=""
          className="bannerImg bannerDesktop"
        />
        <img
          src={bannerImgMobile}
          width="auto"
          alt=""
          className="bannerImg bannerMobile"
        />
        <div className="blackOverlay" />
        <div className="content">
          {userExists !== undefined && (
            <h1>
              {userExists
                ? intl.formatMessage({ ...messages.heading })
                : intl.formatMessage({ ...messages.creationHeading })}
            </h1>
          )}
        </div>
      </div>
      <div className="container profile-container">
        {isFetchingUserExists ? (
          <div className="loader-page">
            <Loader className="lds-black lds-large" />
          </div>
        ) : userExists ? (
          <Status
            setFormModified={setFormModified}
            isFormModified={isFormModified}
            setShowingWarning={setShowingWarning}
            setShowedWarning={setShowedWarning}
          />
        ) : (
          <Routes>
            <Route
              path="/create"
              element={<ProfileCreation setFormModified={setFormModified} />}
            />
          </Routes>
        )}
      </div>
    </div>
  );
};

export default Profile;
